import Service 			from "./../../Libs/Service";

let Layout = new Service({

	Name: "Layout",

	Events: {
		"Current User Loaded": function() {

			if (User.currentUser) {

				//Рабочая среда (какие проекты показывать?)
				this.page = window.localStorage.getItem(`layout-page:${User.currentUser.id}`) || 'playables';
				try {this.pageOptions = JSON.parse(window.localStorage.getItem(`layout-page:${User.currentUser.id}:options`) || '{}') || {}} catch(e) {this.pageOptions = {};}
				this.workspace = window.localStorage.getItem(`layout-workspace:${User.currentUser.id}`) || 'development';
				this.projectsFilter = window.localStorage.getItem(`layout-projects-filter:${User.currentUser.id}`) || '';
				this.versionsFilter = window.localStorage.getItem(`layout-versions-filter:${User.currentUser.id}`) || '';

				if (this.workspace !== 'development') {
					Broadcast.call('Layout Workspace Changed');
					Project.autoSelectProject(true);
				}

				if (this.page === 'banners' && !Metadata.Config['feature-banners']) this.page = 'playables';

				if (this.page !== 'playables') {

					Broadcast.call('Layout Page Changed');
					Broadcast.call(`Layout Page Showed:${this.page}`);

				}

				if (this.projectsFilter) Broadcast.call('Projects Filter Changed', ['from-local-storage']);
				if (this.versionsFilter) Broadcast.call('Versions Filter Changed', ['from-local-storage']);

			}

		},
		"Aside State Changed,Settings Tab Changed,Selected Display Object Changed,Selected Display Object Cleaned": function() {

			this.checkSubAsideToggle();

		},
		"Selected Version Setting Changed": function(settingCodename) {

			if (settingCodename === "creative-template-device") this.setPreviewDeviceFromSettings();
			if (settingCodename === "creative-template-orientation") this.setPreviewOrientationFromSettings();

		},
		"Selected Version Changed": function() {

			this.setPreviewDeviceFromSettings();
			this.setPreviewOrientationFromSettings();

		}
	},

	Actions: {

	},

	init() {

		this.page = 'playables';
		this.pageOptions = {};
		this.pageHistory = [];

		this.workspace = 'development';

		//Высота хидера
		this.headerHeight = 55;

		//Высота второго хидера
		this.subHeaderHeight = 46;

		//Ширина списка проектов
		this.projectsPlaneWidth = {
			'banners': 60,
			'end-cards': 60
		};
		this.projectsPlaneWidthDefault = 60;

		//Ширина списка версий проекта
		this.projectsVersionsPlaneWidth = 250;

		this.previewDevice = 'iPhone';
		this.previewOrientation = {
			iPad: 'portrait',
			iPhone: 'portrait',
			iPhoneX: 'portrait',
			square: 'no'
		};

		//Ширина Aside с настройками версии
		this.asideSize = 390;
		//Ширина второго Aside с подробными настройками
		this.subAsideSize = 300;

		//Открыта ли панель настроек
		this.asideOpened = false;
		//Открыта ли вторая панель настроек
		this.subAsideOpened = false;

		this.projectsFilter = '';
		this.versionsFilter = '';

		this.settingsTabName = '';

		this.invitationRequested = (location.pathname.indexOf('/invitation/') === 0) ? location.pathname.substr(12) : false;

	},

	setPage(page, pageOptions = {}) {

		window.localStorage.setItem(`layout-page:${User.currentUser.id}`, page);
		window.localStorage.setItem(`layout-page:${User.currentUser.id}:options`, JSON.stringify(pageOptions));

		let prevPage = this.page;

		this.page = page;
		this.pageOptions = pageOptions;

		this.pageHistory.push({page, pageOptions: _.cloneDeep(pageOptions)});

		Broadcast.call('Layout Page Changed');
		Broadcast.call(`Layout Page Hided:${prevPage}`);
		Broadcast.call(`Layout Page Showed:${this.page}`);

		Server.sendToSocket({
			Navigation: {
				title: 'Page',
				description: page,
				data: pageOptions
			}
		});

	},

	back() {

		let prevHistory = this.pageHistory[this.pageHistory.length - 2];

		if (prevHistory) this.setPage(prevHistory.page, prevHistory.pageOptions);

	},

	toggleAside() {

		let prevAsideState = this.asideOpened;

		this.asideOpened = !this.asideOpened;

		if (this.asideOpened) document.body.classList.add('aside-menu-show');
		else document.body.classList.remove('aside-menu-show');

		Broadcast.call('Aside State Changed');

		//Если было открыто а сейчас закрываем
		if (prevAsideState) {

			Broadcast.call('Aside State Closing');
			Broadcast.call('Aside State Closed', [], {delay: 200});

		}
		//Если было закрыто а сейчас открываем
		else {

			Broadcast.call('Aside State Opening');
			Broadcast.call('Aside State Opened', [], {delay: 200});

		}

	},

	checkSubAsideToggle() {

		if (this.asideOpened && this.settingsTabName === 'display-objects' && DisplayObject.SelectedDisplayObject) {

			if (!this.subAsideOpened) {

				this.subAsideOpened = true;

				document.body.classList.add('sub-aside-menu-show');

				Broadcast.call('Sub Aside State Changed');

			}

		}

		else {

			if (this.subAsideOpened) {

				this.subAsideOpened = false;

				document.body.classList.remove('sub-aside-menu-show');

				Broadcast.call('Sub Aside State Changed');

			}

		}

	},

	setLayoutWorkspace(workspace) {

		window.localStorage.setItem(`layout-workspace:${User.currentUser.id}`, workspace);

		this.workspace = workspace;

		Broadcast.call('Layout Workspace Changed');

		Project.autoSelectProject(true);

		Server.sendToSocket({
			Navigation: {
				title: 'Workspace',
				description: workspace,
				data: {workspaceCodename: workspace}
			}
		});

	},

	setPublisher(publisherId) {

		Server.sendToSocket({
			ActivePublisher: publisherId,
			Navigation: {
				title: 'Publisher',
				description: Publisher.Publishers[publisherId]?.title,
				data: {publisherId}
			}
		});

	},

	setProject(projectId) {

		Server.sendToSocket({
			ActiveProject: projectId,
			ActiveVersion: window.localStorage.getItem("selected-version-for-project-" + projectId) || null,
			Navigation: {
				title: 'Project',
				description: Project.Projects[projectId]?.title,
				data: {projectId}
			}
		});

	},

	setVersion(versionId) {

		let version = Version.Versions[versionId];

		if (!version) return;

		Server.sendToSocket({
			ActiveVersion: versionId,
			Navigation: {
				title: 'Version',
				description: `${Project.Projects[version['project_id']]?.title} > ${version?.codename || version?.title}`,
				data: {projectId: version['project_id'], versionId}
			}
		});

	},

	setProjectsFilter(filter) {

		this.projectsFilter = filter;

		Broadcast.call("Projects Filter Changed", ['by-user']);

		window.localStorage.setItem(`layout-projects-filter:${User.currentUser.id}`, filter);

	},

	setVersionsFilter(filter) {

		this.versionsFilter = filter;

		Broadcast.call("Versions Filter Changed", ['by-user']);

		window.localStorage.setItem(`layout-versions-filter:${User.currentUser.id}`, filter);

	},

	isFeatureEnabled(...featureNames) {

		return !_.find(featureNames, featureName => !User.currentUser?.options?.['features']?.[featureName]);

	},

	setPreviewDeviceFromSettings() {

		if (Version.SelectedVersion) this.setPreviewDevice(Settings.getSettingValue("creative-template-device") || "iPhone");
		else this.setPreviewDevice("iPhone");

	},

	setPreviewOrientationFromSettings() {

		if (Version.SelectedVersion) this.setPreviewOrientation(Settings.getSettingValue("creative-template-orientation") || "portrait");
		else this.setPreviewOrientation("portrait");

		Broadcast.call("Preview Orientation Changed", [this.previewOrientation[this.previewDevice]]);

	},

	togglePreviewDevice(device) {

		if (this.previewDevice === device) {

			if (device === 'square') this.setPreviewOrientation('no');
			else this.setPreviewOrientation(this.previewOrientation[this.previewDevice] === 'portrait' ? 'landscape' : 'portrait');

		} else {

			this.setPreviewDevice(device);

		}

	},

	setPreviewDevice(device) {

		this.previewDevice = device;

		Broadcast.call("Preview Device Changed", [this.previewDevice]);

	},

	setPreviewOrientation(orientation) {

		this.previewOrientation[this.previewDevice] = orientation;

		Broadcast.call("Preview Orientation Changed", [this.previewOrientation[this.previewDevice]]);

	},

	setSettingsTab(tabName) {

		this.settingsTabName = tabName;

		Broadcast.call("Settings Tab Changed", [tabName]);
		Broadcast.call(`Settings Tab Changed:${tabName}`);

		Server.sendToSocket({
			Navigation: {
				title: 'Settings Tab',
				description: _.capitalize(tabName),
				data: {tabName}
			}
		});

	},

	copyTextToClipboard(text) {

		let textArea = document.createElement("textarea");

		//
		// *** This styling is an extra step which is likely not required. ***
		//
		// Why is it here? To ensure:
		// 1. the element is able to have focus and selection.
		// 2. if element was to flash render it has minimal visual impact.
		// 3. less flakyness with selection and copying which **might** occur if
		//    the textarea element is not visible.
		//
		// The likelihood is the element won't even render, not even a
		// flash, so some of these are just precautions. However in
		// Internet Explorer the element is visible whilst the popup
		// box asking the user for permission for the web page to
		// copy to the clipboard.
		//

		// Place in top-left corner of screen regardless of scroll position.
		textArea.style.position = 'fixed';
		textArea.style.top = 0;
		textArea.style.left = 0;

		// Ensure it has a small width and height. Setting to 1px / 1em
		// doesn't work as this gives a negative w/h on some browsers.
		textArea.style.width = '2em';
		textArea.style.height = '2em';

		// We don't need padding, reducing the size if it does flash render.
		textArea.style.padding = 0;

		// Clean up any borders.
		textArea.style.border = 'none';
		textArea.style.outline = 'none';
		textArea.style.boxShadow = 'none';

		// Avoid flash of white box if rendered for any reason.
		textArea.style.background = 'transparent';


		textArea.value = text;

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			var successful = document.execCommand('copy');
			var msg = successful ? 'successful' : 'unsuccessful';
			console.log('Copying text command was ' + msg);
		} catch (err) {
			console.log('Oops, unable to copy');
		}

		document.body.removeChild(textArea);

	},

	getProjectsPlaneWidth() {

		return (Layout.projectsPlaneWidth[Layout.page] || Layout.projectsPlaneWidthDefault);

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Layout) Layout = window.Layout;
else window.Layout = Layout;

export { Layout }

